import { ResultSet } from "@cubejs-client/core";

import { AppThunk } from "appThunk";
import { cubeLoad } from "modules/helpers/cube/cubeSlice";
import { logError } from "modules/helpers/logger/loggerSlice";

export class ClientRegistration {
    public readonly accountId: string;
    public readonly primaryStoreCategory: string;
    public readonly hasCustomCatchments: boolean;
    public readonly hasCustomCalendar: boolean;

    constructor(
        accountId: string,
        primaryStoreCategory: string,
        hasCustomCatchments: number | boolean,
        hasCustomCalendar: boolean
    ) {
        this.accountId = accountId;
        this.primaryStoreCategory = primaryStoreCategory;
        this.hasCustomCatchments = Boolean(hasCustomCatchments);
        this.hasCustomCalendar = hasCustomCalendar;
    }
}

export const loadClientRegistration = (): AppThunk<Promise<ClientRegistration>> => async (dispatch) => {
    try {
        const query = {
            dimensions: [
                "ClientRegistration.ClientID",
                "ClientRegistration.PrimaryCategory",
                "ClientRegistration.HasCustomCatchments",
                "ClientRegistration.HasCustomCalendar"
            ]
        };
        const resultSet = await dispatch(cubeLoad(query)) as unknown as ResultSet;
        const rawData = resultSet.rawData();
        return new ClientRegistration(
            rawData[0]["ClientRegistration.ClientID"],
            rawData[0]["ClientRegistration.PrimaryCategory"],
            Boolean(rawData[0]["ClientRegistration.HasCustomCatchments"]),
            Boolean(rawData[0]["ClientRegistration.HasCustomCalendar"]),
        );

    } catch (error) {
        dispatch(logError("Error loading ClientRegistration.", error));
        throw error;
    }
};
